import React from "react"
import { Box, Flex, Grid, Heading, Image, Text } from "@theme-ui/components"
import { StructuredText } from "react-datocms"
import {
  isHeading,
  isParagraph,
  isList,
  renderRule,
} from "datocms-structured-text-utils"
import ArrowDown from "../../images/cmatic-arrow-vertical-down.svg"
import { useBreakpointIndex } from "@theme-ui/match-media"

const Intro = ({ title, body, alternate }) => {
  const mediaIndex = useBreakpointIndex()
  return (
    <Box
      sx={{
        display: alternate ? "flex" : "block",
        justifyContent: "space-between",
      }}
    >
      <Grid
        columns={[1, 1, 1, alternate ? 1 : "1fr 2.5fr"]}
        gap={[32, 32, 32, alternate ? 32 : 96]}
        mb={[2, 3, alternate ? 4 : 5, alternate ? 4 : 6]}
        mt={[2, 3, alternate ? 4 : 5, alternate ? 4 : 6]}
        sx={{ width: alternate ? ["100%", "80%", "60%", "50%"] : null }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Heading
            // as="h2"
            sx={{
              textTransform: "uppercase",
              lineHeight:"1.1",
              mt: [0],
            }}
            variant="h2"
          >
            {title}
          </Heading>
          {alternate && mediaIndex <= 2 && (
            <Box sx={{ maxWidth: ["30%", "80%", "40%"], textAlign: "right" }}>
              <Image src={ArrowDown} />
            </Box>
          )}
        </Box>
        <Box
          sx={{
            width: "100%",
            p: alternate
              ? {
                  fontFamily: "roc",
                  fontSize: [2,3, 4, 4],
                }
              : null,
          }}
        >
          <StructuredText
            data={body}
            customNodeRules={[
              renderRule(
                isHeading,
                ({ adapter: { renderNode }, node, children, key }) => {
                  return renderNode(
                    () => {
                      return (
                        <Heading
                          as={`h${node.level}`}
                          variant={`h${node.level}`}
                          color={"primary"}
                          sx={{
                              lineHeight:"1.417"
                          }}
                        >
                          {children}
                        </Heading>
                      )
                    },
                    { key },
                    children
                  )
                }
              ),
              renderRule(
                isParagraph,
                ({ adapter: { renderNode }, node, children, key }) => {
                  return renderNode(
                    () => {
                      return (
                        <Text
                          as="p"
                          mb={3}
                          sx={{
                            fontSize: [
                              2,
                              alternate ? 3 : 4,
                              alternate ? 4 : 5,
                              alternate ? 4 : "40px",
                            ],
                            lineHeight: alternate ? 1.1 : 1.208,
                          }}
                        >
                          {children}
                        </Text>
                      )
                    },
                    { key },
                    children
                  )
                }
              ),
            ]}
          />
        </Box>
      </Grid>
      {alternate && mediaIndex > 2 && (
        <Box sx={{ maxWidth: ["30%", "80%", "40%"], textAlign: "right" }}>
          <Image src={ArrowDown} />
        </Box>
      )}
    </Box>
  )
}

export default Intro
